import React, {Component} from "react";
import "./Skills.css";

import Skill from "./Skill/Skill";

import colors from "colours";
import text from "text";

export default class Skills extends Component
{
	render()
	{
		return (
			<div className="skills">
				<Skill title="Web Development" color={colors.SKILL1} icon="code">
					{text.SKILL_WEBDEV}
				</Skill>

				<Skill title="C# Native Applications" color={colors.SKILL2} icon="computer">
					{text.SKILL_CSHARP}
				</Skill>

				<Skill title="Game Development" color={colors.SKILL3} icon="game">
					{text.SKILL_GAMEDEV}
				</Skill>

				<Skill title="Business Solutions" color={colors.SKILL4} icon="business">
					{text.SKILL_BUSSOL}
				</Skill>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Skills/Skills.js